<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <div class="panel__header">
              <h3 class="panel__title">Add Custom Item</h3>

              <span class="overlay__close" @click="done">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Title</label>
                    </div>

                    <div class="cell auto">
                      <div>
                        <input id="custom-item-title" type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label>Commission</label>
                    </div>

                    <div class="cell auto">
                      <div><input id="custom-item-commission" class="medium-input"
                                  type="text"></div>
                    </div>
                  </div>
                </div>
              </form>

              <div class="text-alert-color text-right" v-if="error">There was an error processing
                your item. Please try again later.
              </div>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="done">Cancel</button>

              <button @click="submitItem">Confirm Custom Item</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'

export default {
  props: [
    'vendorId'
  ],
  mixins: [client, utils],
  data: function () {
    return {
      loading: false,
      error: false
    }
  },
  methods: {
    done () {
      this.$emit('done', false)
    },
    submitItem () {
      this.loading = true
      this.error = false
      let title = document.getElementById('custom-item-title').value
      let commission = document.getElementById('custom-item-commission').value

      let data = {
        title: title,
        commission: commission,
        vendor_id: this.vendorId
      }

      this.request('post', '/orders/create-custom/', data).then(response => {
        this.$emit('done', true)
      }).catch(error => {
        this.loading = false

        if (error) {
          this.error = true
        }
      })
    }
  },
  created () {

  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';

.payout {
  &__totals {
    padding-top: 30px;
  }

  &__total-payout {
    font-size: 24px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/customItem.vue